// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake"}[chunkId] + "." + {"102":"163907fa","133":"c765c84c"}[chunkId] + ".chunk.js";
};